import { Component, OnInit, OnDestroy } from '@angular/core';
import { ItemService, SignalsService, AuthService, PushNotificationService, AlertService } from '../../../services/service.index';
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Forex } from '../../../models/forex.model';

@Component({
    selector: 'app-forex',
    templateUrl: './forex.component.html',
    styles: []
})

export class ForexComponent implements OnInit, OnDestroy {

    count: any;
    colorData = [
        { id: 0, name: 'Ejecución por mercado', color: '#0000B1' },
        { id: 1, name: 'Orden pendiente', color: '' },
        // { id: 2, name: 'Cancelada', color: '#222121' },
    ];
    isColor = this.colorData[0];
    // wcData = [
    //     { id: 0, name: 'Buy Limit', color: '#0000B1', status: '' },
    //     { id: 1, name: 'Buy Stop', color: '#0000B1', status: 'won' },
    //     { id: 2, name: 'Sell Limit', color: '#222121', status: 'lost' },
    //     { id: 3, name: 'Sell Stop', color: '#222121', status: 'canceled' },
    //     { id: 4, name: 'Ejecución Por Mercado', color: '#222121', status: 'market' },

    // ];
    wcData = [
        { id: 0, name: 'ACTIVA', color: '#0000B1', status: '' },
        { id: 1, name: 'GANADA', color: '#0000B1', status: 'won' },
        { id: 2, name: 'PERDIDA', color: '#222121', status: 'lost' },
        { id: 3, name: 'CACELADA', color: '#222121', status: 'canceled' },
    ];
    isWonOrCanceled = this.wcData[0];
    data = [
        { id: 0, name: 'BUY' },
        { id: 1, name: 'SELL' },
    ];
    isBuyOrSell = this.data[0];
    loading = true;
    isActive= false;
    signals: Forex[] = [];
    LastEvaluatedKey = null;
    tag = 'forex';
    signal: Forex = new Forex('', '', '', '', '', '', '', 0, 0, 0, 0, '', '', '', new Date());
    file: any;
    page = 0;
    minidx = 0;
    itemsPerPage = 15;
    private unsubscribe$ = new Subject<void>();
    disabledPush: boolean;

    constructor(private signalsService: SignalsService,
        public _router: Router,
        private auth: AuthService,
        public pushNotification: PushNotificationService,
        private alertService: AlertService,
        private itemService: ItemService
    ) { }

    ngOnInit() {
        this.loadItems();
        this.getSignalMessage();
    }


    getSignalMessage() {
        this.alertService.getSignalMessage().then(res => {
            res.subscribe((alert: any) => {
                this.disabledPush = alert.disabledPush;
            });
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    loadItems() {
        this.signals = [];
        this.loading = true;
        this.signalsService.getForexSignals()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((res: any) => {
                res.docs.forEach(signal => {
                    this.signals.push(
                        new Forex(
                            signal.data().currency,
                            signal.data().description,
                            signal.data().entryPrice,
                            signal.data().stopLoss,
                            signal.id,
                            signal.data().status,
                            signal.data().type,
                            signal.data().tp1,
                            signal.data().tp2,
                            signal.data().tp3,
                            signal.data().tp4,
                            signal.data().color,
                            signal.data().alias,
                            signal.data().picture,
                            signal.data().cdate
                        )
                    );
                });
                this.count = this.signals.length;
                this.signals = intoPages(this.signals, this.itemsPerPage);
                this.loading = false;
            }, error => {
                if (error.status === 0 || error.status === 403) {
                    this.auth.getToken();
                    this.loadItems();
                }
            });
    }

    // loadSearch(searchKey: any) {

    //     if (searchKey.length === 0) {

    //         this.loading = true;
    //         this.loadItems();

    //     } else {

    //         this.itemService.searchItemByName(searchKey, this.tag)
    //             .pipe(takeUntil(this.unsubscribe$))
    //             .subscribe((res: any) => {

    //                 this.signals = JSON.parse(res.body);
    //                 this.count = JSON.parse(res.count);
    //                 this.signals = intoPages(this.signals, this.itemsPerPage);
    //                 this.loading = false;

    //             });
    //     }
    // }

    getFileFromFileUpload(file: File) {

        this.file = file;

    }

    addItem(form: NgForm) {
        if (form.valid) {
            this.signal.currency = form.value.currency;
            this.signal.entryPrice = form.value.entryPrice;
            this.signal.stopLoss = form.value.stoploss;
            this.signal.description = form.value.description;
            this.signal.tp1 = form.value.tp1;
            this.signal.tp2 = form.value.tp2;
            this.signal.tp3 = form.value.tp3;
            this.signal.tp4 = form.value.tp4;
            this.signal.status = '';
            this.signal.type = this.isBuyOrSell.name;
            this.signal.color = this.isColor.color;
            this.signal.alias = form.value.alias;
            this.signal.cdate = new Date();
            Swal.fire({
                title: 'Agregando la señal!',
                html: 'Espere unos segundos.',
                onBeforeOpen: () => {
                    Swal.showLoading();
                }
            });
            if (this.file) {
                this.itemService.uploadFile(this.file, this.tag)
                    .then((link: any) => {
                        this.signal.picture = link;
                    }).catch((err: Error) => {
                        Swal.close();
                        Swal.fire('El Ítem no ha sido creado!',
                            'Su ítem no ha sido creado por problemas con la imagen.', 'error');
                        form.reset();
                    }).finally(() => {
                        try {
                            this.createSignal(this.signal);
                        } catch (err) {
                            Swal.fire('El ítem no ha sido creado!', 'Contacte a soporte.',
                                'error');
                            console.log(err);
                        }
                    });
            } else {
                Swal.fire('El ítem no ha sido creado!', 'Debe de ingresar un archivo de imagen válido.',
                    'error');
            }
        }
    }

    createSignal(signal: Forex) {
        if (!this.disabledPush) {
            this.pushNotification.postPushNotificationForex(this.signal)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((pushRes: any) => {
                    console.log(pushRes);
                }, error => {
                    console.log(error);
                });
            this.signalsService.createForexSignal(this.signal).then(
                res => {
                    console.log(res);
                    Swal.fire(
                        'La señal ha sido agregada con éxito!',
                        'Los cambios al evento podran ser visualizados en el app. ',
                        'success'
                    ).then((res2: any) => {
                        this.signal = new Forex('', '', '', '', '', '', '', 0, 0, 0, 0, '', '', '', new Date());
                    }).finally(() => {
                        this.loadItems();
                    });
                }
            );
        }
    }

    refresh(): void {
        window.location.reload();
    }

    parseTags(tagsFromItem: string): any {
        if (tagsFromItem.length > this.tag.length) {
            return true;
        } else {
            return false;
        }
    }

    firstPage() {
        this.page = 0;
        this.minidx = 0;
    }

    setPage(pageNumber: number) {
        this.page = pageNumber;
    }

    incPage() {
        if (this.page < this.signals.length - 1) {
            this.page = this.page + 1;
            if (this.page >= this.minidx + 9) {
                if (this.minidx + 10 < this.signals.length) {
                    this.minidx = this.minidx + 1;
                }
            }
        }
    }

    decPage() {
        if (this.page > 0) {
            this.page = this.page - 1;
            if (this.page < this.minidx + 1) {
                if (this.minidx > 0) {
                    this.minidx = this.minidx - 1;
                }
            }
        }
    }

    loadItemModal(itemToModal: Forex) {
        this.signal = itemToModal;
        switch (this.signal.status) {
            case '':
                this.isWonOrCanceled = this.wcData[0];
                break;
            case 'won':
                this.isWonOrCanceled = this.wcData[1];
                break;
            case 'lost':
                this.isWonOrCanceled = this.wcData[2];
                break;
            case 'canceled':
                this.isWonOrCanceled = this.wcData[3];
                break;
            default:
                break;
        }
    }

    updateItem(form: NgForm) {
        let changed = false;
        if (this.signal.status !== this.isWonOrCanceled.status) {
            this.signal.color = this.isWonOrCanceled.color;
            this.signal.status = this.isWonOrCanceled.status;
            changed = true;
        }
        if (form.value.stoploss !== null && form.value.stoploss !== '') {
            this.signal.stopLoss = form.value.stoploss;
            changed = true;
        }
        if (form.value.description !== null && form.value.description !== '') {
            this.signal.description = form.value.description;
            changed = true;
        }
        if (changed) {
            this.signalsService.updateForexSignal(this.signal)
                .then(res => {
                    Swal.fire({
                        title: 'Editando la señal!',
                        html: 'Espere unos segundos.',
                        onBeforeOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    // if (!this.disabledPush) {
                    //     this.pushNotification.updatePushNotificationForex(this.signal)
                    //         .pipe(takeUntil(this.unsubscribe$))
                    //         .subscribe((pushRes: any) => {
                    //             console.log(pushRes);
                    //         }, error => {
                    //             console.log(error);
                    //         });
                    // }
                }).catch(err => {
                    Swal.fire('La señal no ha sido creada con éxito!', 'Su señal creada no podrá ser visualizada en la aplicación.',
                        'error');
                }).finally(() => {
                    Swal.close();
                    Swal.fire('La señal ha sido creada con éxito!', 'Su señal creada podrá ser visualizada en la aplicación.',
                        'success')
                        .then((res: any) => {
                            this.signal = new Forex('', '', '', '', '', '', '', 0, 0, 0, 0, '', '', '', new Date());
                        });

                }
                );
        }
    }



    deleteItem(signal: Forex) {
        console.log(signal);
        Swal
            .fire({
                title: 'Estás seguro?',
                text:
                    'Se eliminara la señal: ' +
                    signal.signalId,
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#06d79c',
                cancelButtonColor: '#ef5350',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                reverseButtons: true
            })
            .then(result => {
                if (result.value) {
                    Swal.fire({
                        title: 'Eliminando la señal!',
                        html: 'Espere unos segundos.',
                        onBeforeOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    this.signalsService.deleteForexSignal(signal.signalId)
                        .then((res: any) => {
                            Swal.close();
                            Swal.fire(
                                'Eliminado',
                                'La señal ha sido eliminada.',
                                'success'
                            );
                            this.loadItems();
                        }).catch(error => {
                            Swal.close();
                            console.log(error);
                            Swal.fire(
                                'Error',
                                'El señal no ha sido eliminada.',
                                'error'
                            );
                        });
                } else if (
                    result.dismiss === Swal.DismissReason.cancel
                ) {
                    console.log('No action');
                }
            });
    }
}



export function intoPages(arr: any, pagelen: any) {
    const out = [];
    if (pagelen > arr.length) { out.push(arr); } else {
        for (let i = 0; i < Math.ceil(arr.length / pagelen); i++) {
            out.push(arr.slice(i * pagelen, (i + 1) * pagelen));
        }
    }
    return out;
}
